































































































































































    import _ from 'lodash';
    import { PageModeMixin } from '@/main/mixins/pageMode';
    import { genVuexComputeds } from '@/main/pages/editFactory';
    import { Partner } from '@/modules/kartoteka/partner';
    import { Dodavatel } from '@/modules/ciselnik/skladove/dodavatel';
    import { OrganizacniJednotky } from '@/modules/administrace/organizacniJednotky';
    import { BankovniUcet } from '@/modules/ciselnik/firemni/bankovniUcet';

    import { mapMutationsDvm } from '@/main/pages';

    import { PageMode } from '@/main/utils/pageMode';

    import { DefaultCurrency } from '@/modules/servis/zakazka/components/AdvancePay/constants';

    import { store } from '../store/edit';
    import { types } from '../store/types';

    import { NAME, TAB_NAMES, TABS2, TABS3 } from '../constants';

export default PageModeMixin.extend({
	name: 'UdajeOFirme',
	components: {
		DealerSelect: OrganizacniJednotky.components.Select,
		DodavatelSelect: Dodavatel.components.Select,
		PartnerSelect: Partner.components.Select,
		BankovniucetSelect: BankovniUcet.components.Select,
	},
	props: {
		storeUri: { type: String, default: null },
	},
	data() {
		return {
			tabNames: TAB_NAMES,
			disabledSeconds: [1, 59],
		};
	},
	computed: {
		tabItems() {
			const tabItems = [];

                if (this.hasTabAccess(NAME, TABS2.Banka1)) tabItems.push(TAB_NAMES.BANKA1);
                if (this.hasTabAccess(NAME, TABS2.Banka2)) tabItems.push(TAB_NAMES.BANKA2);

                return _.pick(TABS2, tabItems);
            },
            tabItemsTel() {
                const tabItems = [];

                if (this.hasTabAccess(NAME, TABS3.TelmobNr)) tabItems.push(TAB_NAMES.TELMOBNR);
                if (this.hasTabAccess(NAME, TABS3.FaxNr)) tabItems.push(TAB_NAMES.FAXNR);
                if (this.hasTabAccess(NAME, TABS3.TelsmNr)) tabItems.push(TAB_NAMES.TELSMNR);
                if (this.hasTabAccess(NAME, TABS3.TelnvNr)) tabItems.push(TAB_NAMES.TELNVNR);
                if (this.hasTabAccess(NAME, TABS3.TelovNr)) tabItems.push(TAB_NAMES.TELOVNR);
                if (this.hasTabAccess(NAME, TABS3.TelskladNr)) tabItems.push(TAB_NAMES.TELSKLADNR);

                return _.pick(TABS3, tabItems);
            },
            ...genVuexComputeds(store),
            mutationsMappers() {
                return {
                    dodavatel: `${this.storeUri}/${types.mutations.DODAVATEL_SELECT_MAPPER}`,
                    intrZakaznik: `${this.storeUri}/${types.mutations.INTR_ZAKAZNIK_SELECT_MAPPER}`,
                    primaryBankList: `${this.storeUri}/${types.mutations.PRIMARY_BANK_SELECT_MAPPER}`,
                    secondaryBankList: `${this.storeUri}/${types.mutations.SECONDARY_BANK_SELECT_MAPPER}`,
                    dealerKVPSCode: `${this.storeUri}/${types.mutations.DEALERKVPS_SELECT_MAPPER}`,
                };
            },
            intrZakaznikFilter(): Record<string, any> {
                return {
                    ZakaznikId: this.IntrZakaznikId,
                    // TODO: API: upravit možnosti filtrování - typ partnera by měl jít nastavit na hodnotu 4
                    // Needs to be commented till Internal Type is implemented on Customer Screen
                    // PartnertypPzn: Partner.types.INTERNI,
                };
            },
            isGstNumberVisible() {
                return this.dmsSys.EnableGSTPrp && !this.dmsSys.EnableInvestorDealerPrp;
            },
            isVatNrVisible() {
                return !this.dmsSys.EnableGSTPrp && this.dmsSys.EnableInvestorDealerPrp;
            },
            isDisabled():boolean {
                return this.pageMode === PageMode.EDIT;
            },
            getCurrency() {
                this.MenaId2 = (this.dropdownList.MenaKod as any).filter((x:any) => x.Text === DefaultCurrency.PrimaryText || x.Text === DefaultCurrency.SecondaryText)[0]?.Value;
                return this.MenaId2;
            },
        },

        methods: {
            ...mapMutationsDvm(store.mutations),
        },
    });
